<template>
  <div id="industries" class="section">
    <div class="container">
      <article class="col s12">
        <h3 class="is-size-3">{{ $t("title") }}</h3>
        <hr class="line" />
      </article>
      <br />
      <br />
      <section class="table-container" style="overflow: scroll">
        <table
          class="table is-bordered is-fullwidth is-hoverable has-background-white"
          style="background-color: rgb(255 255 255 / 60%)"
          data-aos="zoom-in"
          data-aos-delay="20"
          data-aos-duration="500"
        >
          <thead>
            <tr>
              <th class="has-text-centered" style="vertical-align: middle">
                <b class="is-size-4">{{ $t("title") }}</b>
              </th>
              <th
                class="has-text-centered"
                v-for="(col, i) in $t('columns')"
                :key="i"
                style="width: 15%"
              >
                <img
                  v-bind:src="getImgUrl(col.icon)"
                  :alt="col.name"
                  style="height: 80px; vertical-align: bottom"
                />
                <br />
                {{ col.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in $t('tableData')" :key="i">
              <td>
                <b>{{ item.name }}</b>
              </td>
              <td class="has-text-centered" v-for="(m, i) in item.mark" :key="i">
                <!-- <i :class="`fa-solid fa-${m} fa-2x`"></i> -->
                <IconIdustries :type="m" />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>
<script>
import IconIdustries from "../components/iconIndustries.vue";
export default {
  name: "Industries",
  components: { IconIdustries },
  data() {
    return {
      activeTab: 0,
      showBooks: false,
    };
  },
  methods: {
    getImgUrl(icon) {
      return require(`@/assets/icon/${icon}.svg`);
    },
  },
};
</script>
<i18n>
{
  "es":{
    "title": "Industrias",
    "columns":[
        {
          "name":"Bancos / Servicios financieros",
          "icon":"bank"
        },
        {
          "name":"Compañías de seguros",
          "icon":"secure"
        },
        {
          "name":"Corredoras de bolsas y administradoras de fondos",
          "icon":"admin"
        },
        {
          "name":"Empresas industriales/Retail",
          "icon":"retail"
        },
        {
          "name":"Sujetos obligados no financieros",
          "icon":"subject"
        },
        {
          "name":"Fintech",
          "icon":"fintech"
        },
        {
          "name":"Automotoras",
          "icon":"sedan"
        }
    ],
    "tableData":[
      {"name":"AML/Compliance", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Prevención de fraude", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Abuso de mercado", "mark":["❌","❌","✔️","❌","❌","❌","❌"]},
      {"name":"Auditoría continua", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Portal ético", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Monitoreo de procesos", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Conoce tu cliente (KYC)", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Búsqueda de personas en listas de sanciones", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Logs de auditoría", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]},
      {"name":"Panel de gestión", "mark":["✔️","✔️","✔️","✔️","✔️","✔️","✔️"]}
    ]
  },
  "en":{
    "title": "Industries",
    "columns":[
        {
          "name":"Bank / Financial Services",
          "icon":"bank"
        },
        {
          "name":"Insurance companies",
          "icon":"secure"
        },
        {
          "name":"Stock Brokers and Asset Management",
          "icon":"admin"
        },
        {
          "name":"Industrial/Retail Companies",
          "icon":"retail"
        },
        {
          "name":"Non-Financial Entities",
          "icon":"subject"
        },
        {
          "name":"Fintech",
          "icon":"fintech"
        },
        {
          "name":"Automotive",
          "icon":"sedan"
        }
    ],
   "tableData":[
      {"name":"AML/Compliance", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Fraud prevention", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Market abuse", "mark":["❌","❌","✔️","❌","❌", "❌","❌"]},
      {"name":"Continuous audit", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"External Complaints Channel", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Process monitoring", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Know Your Customer (KYC)", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"People search in sanctions lists", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Audit logs", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Management Dashboard", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]}
    ]
  },
  "pt":{
    "title": "indústrias",
    "columns":[
        {
          "name":"Bancos e Serviços Financeiros",
          "icon":"bank"
        },
        {
          "name":"Seguradoras",
          "icon":"secure"
        },
        {
          "name":"Corretoras de Valores Mobiliários e de gestão de ativos financeiros",
          "icon":"admin"
        },
        {
          "name":"Indústrias e Comércio",
          "icon":"retail"
        },
        {
          "name":"Entidades não-financeiras",
          "icon":"subject"
        },
                {
          "name":"Fintech",
          "icon":"fintech"
        },
        {
          "name":"Automotivo",
          "icon":"sedan"
        }
    ],
    "tableData":[
      {"name":"Compliance/Anti-lavagem de dinheiro", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️", "✔️"]},
      {"name":"Prevenção de fraudes", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Abuso de Mercado", "mark":["❌","❌","✔️","❌","❌", "❌","❌"]},
      {"name":"Auditoria Contínua", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Canal de reclamações", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Monitoramento de Processos", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Conheça seu cliente/KYC", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Buscador listas sancionados", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Registros de auditoria", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]},
      {"name":"Panel de gestión ", "mark":["✔️","✔️","✔️","✔️","✔️", "✔️","✔️"]}
    ]
  }
}
</i18n>
